import { SecurityPageProps } from "models/security";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import ContainerFlex from "components/ContainerFlex";
import * as St from "./styles";
import { RouteNames } from "routes/routes";
import moment from "moment";
import { hiddenCardNumberTwo, moneyMask } from "utils/mask";
import { LOCAL_STORE_CLIENTE } from "../../../../../constants";
import { getItemLocalStore } from "utils/storeUtils";
import KeyboardWrapper from "components/Keyboard";
import Input from "components/input";
import { showMessage } from "utils/messages";
import { addTypeFlowState } from "redux/features/security/security-slice";
import { addValuePaymentInvoice } from "redux/features/cliente/cliente-slice";

const ValueCapture: React.FC<SecurityPageProps> = ({
  title,
  description = "",
}) => {
  const history = useHistory();

  const dispatch = useAppDispatch();

  const {
    cliente: { paymentInvoice, faturaList },
  } = useAppSelector((state) => state.cliente);
  const { typeFlow } = useAppSelector((state) => state.security);

  const { dadosLogin, nome } = getItemLocalStore(LOCAL_STORE_CLIENTE);

  const handleVoltar = () => {
    history.push(RouteNames.ATENDIMENTO_FATURA);
    dispatch(addTypeFlowState("fatura"));
  };

  const [input, setInput] = useState(
    moneyMask(faturaList?.data.saldo_devedor)
      ?.replace(/[^0-9,]*/g, "")
      .replace(",", "")
      .replace(".", "")
  );
  const [value, setValue] = useState("");
  const keyboard = useRef<any>(null);

  useEffect(() => {
    keyboard.current.setInput(
      moneyMask(faturaList?.data.saldo_devedor)
        ?.replace(/[^0-9,]*/g, "")
        .replace(",", "")
        .replace(".", "")
    );
  }, [faturaList]);

  useEffect(() => {
    setValue(
      new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(input) / 100)
    );
  }, [input]);

  const handleSubmit = () => {
    try {
      const valorInserido = value.replace(/[^0-9,]*/g, "").replace(",", ".");

      if (valorInserido <= "0" || valorInserido <= "0.00") return;

      dispatch(addValuePaymentInvoice(valorInserido));

      if (typeFlow === "fatura-pagamento-credito") {
        history.push(RouteNames.RESUMO_CREDITO_FATURA_PAGAMENTO);
      } else if (typeFlow === "fatura-pagamento-debito") {
        const propsRouter: SecurityPageProps = {
          nextStep: RouteNames.FEEDBACK_FATURA_PINPAD,
          backStep: RouteNames.ATENDIMENTO_FATURA,
          installmentPaymentInvoice: "1",
          title: "Pagar com cartão de débito",
          description:
            "Tudo certo! Agora confirme no Pinpad o valor selecionado e aproxime ou insira o teu cartão de débito.",
        };

        history.push({
          pathname: RouteNames.FEEDBACK_FATURA_PINPAD,
          state: { ...propsRouter },
        });
      }
    } catch (error) {
      showMessage("warning", "Atenção!", "Tente novamente.");
    }
  };

  return (
    <ContainerFlex center flex={1} horizontal>
      <ContainerFlex center>
        <St.Title>Pagar com cartão</St.Title>
      </ContainerFlex>

      <ContainerFlex center>
        <St.Description>
          <span>
            Por favor, digite <span>qual valor deseja pagar</span> em seguida,
            pressione a tecla
            <br />
            verde (Entra) para continuar:
          </span>
        </St.Description>
      </ContainerFlex>
      <ContainerFlex center>
        <ContainerFlex justifyContent="space-between" row>
          <ContainerFlex align="flex-end">
            <ContainerFlex width={80} style={{marginBottom: "20px"}} gap="30">
             <div style={{marginBottom: '20px'}}>
             <Input
                label="Valor"
                style={{
                  height: "100%",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "bold",
                  padding: "8px",
                }}
                name="valorInfo"
                value={value}
                onChange={(e) => setValue(e)}
                edit
                disabled
              />
             </div>
              <KeyboardWrapper
                onPressBack={handleVoltar}
                keyboardRef={keyboard}
                onChange={setInput}
                typeKeyboard="numeric"
                onPressEnter={() => handleSubmit()}
              />
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex center width={45} maxWidth={45}>
            <ContainerFlex center padding={25}>
              <ContainerFlex
                padding={15}
                color="#fbfbfb"
                width={80}
                height={50}
                maxWidth={100}
                maxHeight={350}
                scroll
                hidden
              >
                <ContainerFlex row>
                  <ContainerFlex>
                    <St.SpanTextTitleBold>Cliente:</St.SpanTextTitleBold>
                    <St.SpanTextTitle>{nome}</St.SpanTextTitle>
                  </ContainerFlex>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextTitleBold>Cartão:</St.SpanTextTitleBold>
                    <St.SpanTextTitle>
                      {hiddenCardNumberTwo(
                        dadosLogin?.numeroCartaoTeucard,
                        4,
                        12,
                        ".****.****."
                      )}
                    </St.SpanTextTitle>
                  </ContainerFlex>
                </ContainerFlex>
                <St.Dividers />

                <St.SpanTextTitleBold>
                  Resumo da fatura atual
                </St.SpanTextTitleBold>
                <ContainerFlex row center>
                  <St.SpanTextTitle>Vencimento:</St.SpanTextTitle>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextValue>
                      {moment(paymentInvoice?.dataVencimento).format(
                        "DD/MM/YYYY"
                      )}
                    </St.SpanTextValue>
                  </ContainerFlex>
                </ContainerFlex>

                <ContainerFlex center row>
                  <St.SpanTextTitle>Status:</St.SpanTextTitle>
                  <ContainerFlex end align="flex-end">
                  <St.SpanTextTitle>{faturaList?.data?.status}</St.SpanTextTitle>
                  </ContainerFlex>
                </ContainerFlex>
                <ContainerFlex row center>
                  <St.SpanTextTitle>Saldo devedor:</St.SpanTextTitle>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextValue>
                      {moneyMask(faturaList?.data?.saldo_devedor)}
                    </St.SpanTextValue>
                  </ContainerFlex>
                </ContainerFlex>
                <ContainerFlex row center>
                  <St.SpanTextTitle>Valor total:</St.SpanTextTitle>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextValue>
                      {moneyMask(paymentInvoice?.saldoFaturaAtual)}
                    </St.SpanTextValue>
                  </ContainerFlex>
                </ContainerFlex>

                <ContainerFlex row center>
                  <St.SpanTextTitle>Valor mínimo:</St.SpanTextTitle>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextValue>
                      {moneyMask(paymentInvoice?.valorMinimoRecebido)}
                    </St.SpanTextValue>
                  </ContainerFlex>
                </ContainerFlex>
                <St.Dividers />
              </ContainerFlex>
            </ContainerFlex>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default ValueCapture;
